// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"wq_a bhv_b bhv_ux"};